import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {UserService} from '../../core/services/user/user.service';
import {User} from '../../core/services/user/user.model';
import {ActivatedRoute} from '@angular/router';
import {getSubsidyConfig} from '../../subsidies.config';
import {SubsidyType} from '../../models/subsidy-type.type';

@Component({
	selector: 'tvsub-completed',
	templateUrl: './completed.component.html',
	styleUrls: ['./completed.component.scss'],
	standalone: false
})
export class CompletedComponent implements OnInit {
	email: string;
	subsidyText: string;
	user$: Observable<User | null>;

	constructor(private route: ActivatedRoute, private userService: UserService) {}

	ngOnInit() {
		window.scrollTo(0, 0);

		const config = getSubsidyConfig(this.getType());

		this.email = this.route.snapshot.data.email || config?.email || 'subsidies@toerismevlaanderen.be';
		this.subsidyText = this.route.snapshot.data.subsidyText || (config ? (config.text || `subsidie in het kader van ${config.name}`) : 'subsidie');
		this.user$ = this.userService.user$;
	}

	private getType(): SubsidyType | undefined {
		const typeRegex = /^\/([A-z0-9_-]+)\//;
		const result = typeRegex.exec(location.pathname);

		if (result) {
			return result[1] as SubsidyType;
		}

		return undefined;
	}
}
